import { StorageService } from "@/services/storageService";
import type { ResolvedSignedUrlResponse } from "@/services/storageService.types";
import { useCallback, useMemo } from "react";

import { useAPI } from "../useAPI";
import { buildSignedUrlCacheKey, getOrFetchSignedUrl } from "./signedUrlCache";

/** Imperative signed-URL fetcher for `/storage/{fileId}`. Results are shared with the module-level signed-URL cache. */
export function useGetSignedUrl(): {
  getSignedUrl: (fileId: string, type?: string) => Promise<ResolvedSignedUrlResponse>;
} {
  const api = useAPI();
  const storageService = useMemo(() => new StorageService(api), [api]);

  const getSignedUrl = useCallback(
    (id: string, t: string = "file"): Promise<ResolvedSignedUrlResponse> =>
      getOrFetchSignedUrl(buildSignedUrlCacheKey(id, t), () => storageService.getSignedUrl(id, t)),
    [storageService]
  );

  return { getSignedUrl };
}
